import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CartUndoService } from '@cart/feature';
import { ProgressCircleComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';

@Component({
  selector: 'sd-cart-undo-delete-toast',
  imports: [ProgressCircleComponent],
  templateUrl: './cart-undo-delete-toast.component.html',
  styleUrls: ['./cart-undo-delete-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartUndoDeleteToastComponent {
  private deviceService = inject(DeviceService);
  private cartUndoService = inject(CartUndoService);

  protected readonly isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$, { initialValue: false });
  protected readonly isUndoVisible = this.cartUndoService.isUndoVisible;
  protected readonly secondsLeft = this.cartUndoService.secondsLeft;
  protected readonly initialSeconds = this.cartUndoService.initialSeconds;

  protected undo(): void {
    this.cartUndoService.undo();
  }
}
